import { jsx as i } from "react/jsx-runtime";
import { createContext as u, useRef as l, useMemo as a, useContext as f } from "react";
const n = u(null), d = () => f(n), P = ({
  children: s
}) => {
  const t = l({}), c = a(
    () => ({
      register(e, r) {
        t.current[e] = r;
      },
      unregister(e) {
        delete t.current[e];
      },
      notifyPlay(e) {
        const r = t.current;
        Object.keys(r).forEach((o) => {
          o !== e && r[o]();
        });
      }
    }),
    []
  );
  return /* @__PURE__ */ i(n.Provider, { value: c, children: s });
};
export {
  P as VideoPlayerProvider,
  d as useVideoPlayerContext
};
//# sourceMappingURL=VideoPlayerProvider.mjs.map
